<div class="container" style="margin-top:75px;">
  <div class="row">
    <p>This page helps test to make sure data is coming down from the API layer as I expect it to.</p>
    <div class="col-6-md">
        <ul>
            <li *ngFor="let i of TestData;let MyIndex=index; let IsOdd=odd; let IsEven=even">{{i}}</li>
          </ul>
    </div>
  </div>
</div>


